
import Event = createjs.Event;

export class Poker2GiveChipsEvent extends Event {
    /** C2S: Will be fired if the the client has sent chips to another player. **/
    public static CHIPS_SENT: string = "chipsSent";

    /** S2C: Serverresponse if the giving chips process has been successful. **/
    public static CHIPS_SENT_SUCCESS: string = "chipsSentSuccess";

    public params: any[] = null;

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
